import React, { useEffect, useState } from 'react';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import * as yup from 'yup';
import { SelectLayoutItem, TextFieldLayoutItem } from 'models/InputLayoutItem';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { FinancialList } from 'constants/FinancialList';
import { FORM, LAYOUT_ITEM, PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';

const storageService = new StorageServiceImpl();

export const PortabilidadPaso5 = () => {
	const financialInstitutionName = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.FINANCIAL_INSTITUTION_NAME,
		sessionStorage
	);
	const vehiclePlate = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.VEHICLE_PLATE,
		sessionStorage
	);
	const otherFinancialInstitution = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.OTHER_FINANCIAL,
		sessionStorage
	);

	const [fields, setfields] = useState<any[]>([
		{
			defaultValue: financialInstitutionName ? financialInstitutionName : '',
			label: 'Nombre de la financiera',
			name: FORM.FINANCIAL_INSTITUTION_NAME,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: FinancialList,
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			label: 'Nº de patente a portar',
			defaultValue: vehiclePlate ? vehiclePlate : '',
			name: FORM.VEHICLE_PLATE,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: AABB99',
			validation: yup
				.string()
				.required('Campo Requerido')
				.matches(/^[A-Za-z]{4}\d{2}$/, 'Ingrese una patente válida')
				.length(6, 'Formato incorrecto'),
		} as TextFieldLayoutItem,
	]);

	const addElement = (element: any) => {
		let newFields = fields;
		newFields.splice(1, 0, element);
		setfields(newFields);
	};
	const deleteElement = () => {
		let newFields = fields;
		newFields.splice(1, 1);
		setfields(newFields);
	};

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_5),
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Información del crédito a portar"
				body="Usaremos esta información para consultar la deuda que quieres portar"
			/>

			<CreateFormLayout
				fields={fields}
				watchField={['financialInstitutionName']}
				customEvent={(values) => {
					if (values.financialInstitutionName === 'other' && fields.length <= 2) {
						addElement({
							label: '¿Cuál es el nombre de la financiera?',
							defaultValue: otherFinancialInstitution ? otherFinancialInstitution : '',
							name: FORM.OTHER_FINANCIAL,
							type: LAYOUT_ITEM.TYPE.INPUT,
							placeholder: 'Ej: Banco Bice',
							validation: yup
								.string()
								.required('Campo Requerido')
								.matches(/^[a-zA-Z ]+$/, 'Ingresa un nombre de financiera válido')
								.min(3, 'Ingresa un nombre de financiera válido')
								.max(25, 'Ingresa un nombre de financiera válido'),
						});
					} else if (values.financialInstitutionName !== 'other' && fields.length > 2) {
						deleteElement();
					}
				}}
			/>
		</div>
	);
};
